var request = new XMLHttpRequest();
var tmpTraits = {};
var filePaths = ['/data/s01/background.json', '/data/s01/body.json', '/data/s01/face.json', '/data/s01/clothes.json', '/data/s01/hair.json', '/data/s01/accessory.json'];
var traitTypes = ['background', 'body', 'face', 'clothes', 'hair', 'accessory'];

for(var i = 0; i < filePaths.length; i++){
  request.open("GET", filePaths[i], false);
  request.send(null)
  tmpTraits[i] = JSON.parse(request.responseText);
  tmpTraits[traitTypes[i]] = JSON.parse(request.responseText);
}

export const traitsS01 = tmpTraits;
//console.log(traitsS01);
